// Styles
import './_main-collection.scss';